module.exports = __webpack_public_path__ + "img/home-part-02.55a21345.png";